'use client';

import { useState } from 'react';
import { cn } from '@/core/utils/cn';
import { Search, X } from 'lucide-react';

interface SearchInputProps {
  id?: string;
  placeholder?: string;
  value?: string;
  onChange?: (value: string) => void;
  className?: string;
}

export function SearchInput({ id, placeholder = 'Search...', value: controlledValue, onChange, className }: SearchInputProps) {
  const [internalValue, setInternalValue] = useState('');
  const value = controlledValue ?? internalValue;

  const handleChange = (v: string) => {
    setInternalValue(v);
    onChange?.(v);
  };

  return (
    <div className={cn('relative', className)}>
      <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-hms-textDim" />
      <input
        id={id}
        type="text"
        value={value}
        onChange={(e) => handleChange(e.target.value)}
        placeholder={placeholder}
        className={cn(
          'w-full h-9 pl-9 pr-8 text-[13px] text-hms-text bg-hms-bg border border-hms-border rounded-lg',
          'placeholder:text-hms-textDim',
          'focus:outline-none focus:ring-2 focus:ring-hms-gold/30 focus:border-hms-gold/50',
          'transition-colors duration-150'
        )}
      />
      {value && (
        <button id="shared-search-input-btn-1"
          onClick={() => handleChange('')}
          className="absolute right-3 top-1/2 -translate-y-1/2 text-hms-textDim hover:text-hms-text"
        >
          <X className="w-3.5 h-3.5" />
        </button>
      )}
    </div>
  );
}
